import React from "react";
import { Grid } from "@mui/material";

const MainLayout = ({ Children }) => {
  return (
    <Grid container style={mainLayoutStyles}>
      {Children}
    </Grid>
  );
};

export default MainLayout;

const mainLayoutStyles = {
  height: "100vh",
  paddingLeft: 10,
  paddingTop: 50,
  background: "#F5F5F5",
  fontFamily: "Avenir Book, sans-serif"
};
